import React from 'react'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import ServicesBgVideo from '../assets/services-bg.mp4'
import ServicesPoster from '../assets/poster.png'
import Service1 from '../assets/images/ai-agents-bots.png'
import Service2 from '../assets/images/gen-ai.png'
import Service3 from '../assets/images/ai-automation.png'
import Service4 from '../assets/images/ai-consulting.png'
import Service5 from '../assets/images/cloud-migration.png'
import Service6 from '../assets/images/aws-managed-services.png'
import Service7 from '../assets/images/cloud-security.png'
import Service8 from '../assets/images/devops.png'
import Service9 from '../assets/images/cloud.png'
import Service10 from '../assets/images/backend.png'
import Service11 from '../assets/images/data.png'
import Service12 from '../assets/images/digital-transformation.png'
import Service13 from '../assets/images/advisory.png'
import ToTop from '../components/ToTop'

export default function Services() {
  return (
    <div>
        {/* Hero section */}
        <div className="services-hero">
          <div className="services-hero-overlay"></div>
          <video className="services-hero-video" src={ServicesBgVideo} poster={ServicesPoster} autoPlay loop muted playsInline webkit-playsInline />
          <div className="services-hero-content">
            <span className="services-hero-eyebrow">Our services</span>
            <h1>From idea to outcome.</h1>
            <p className="services-hero-sub">We engineer the journey: AI, cloud, engineering and consulting.</p>
            <div className="services-hero-cta">
              <HashLink to="./#pillars" className="services-hero-btn services-hero-btn-primary">Explore our services</HashLink>
              <Link to="/Contact" className="services-hero-btn services-hero-btn-ghost">Talk to us</Link>
            </div>
          </div>
        </div>
      {/* Hero section ends*/}

            <section className="pillar-group">
{/* ============ PILLAR 1: AI SOLUTIONS ============ */}
      <div className="pillar-band" id="pillars">
        <div className="container">
          <h2 className="fw-bold pillar-title">AI Solutions</h2>
        </div>
      </div>

      {/* AI Agents */}
      <div className="section-bg1 border-bottom border-secondary" id="ai-agents">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-4">
              <img src={Service1} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>AI Agents: Voice, Sales &amp; Support</h3>
              <p>AI agents handle customer conversations the way your best support rep would, without the shift schedule. Jaggulas Consulting builds voice and chat agents on AWS Bedrock and Amazon Connect that answer calls, qualify inbound leads, resolve common support queries, and escalate to a human only when it genuinely matters. For healthcare and financial services businesses in South Africa, that means consistent, compliant customer interactions around the clock, without scaling headcount.</p>
              <p>Our agents are trained on your own knowledge base, integrate with your existing CRM and ticketing systems, and are deployed within South Africa's af-south-1 AWS region to keep data residency aligned with POPIA. Whether the goal is faster lead response or fewer support backlogs, we design the agent around the specific business outcome you are chasing rather than a generic chatbot template.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Generative AI Development */}
      <div className="section-bg2 border-bottom border-secondary" id="generative-ai-development">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>Generative AI Development (LLM, RAG &amp; Agentic Systems)</h3>
              <p>Off-the-shelf AI tools rarely understand your business the way a system trained on your own data can. Jaggulas Consulting designs and builds custom generative AI solutions, large language model integrations, retrieval-augmented generation pipelines, and multi-step agentic systems, using AWS Bedrock as the foundation. This is the engineering layer underneath production-ready AI agents, internal copilots, and document intelligence tools, built to work with your existing data rather than against it.</p>
              <p>We take projects from proof of concept through to production, with particular focus on regulated industries where data residency and accuracy matter. For healthcare and financial services clients across South Africa, that means generative AI systems hosted in AWS's af-south-1 region, evaluated against real business scenarios before going live, and designed so your team can maintain and extend them after handover.</p>
            </div>
            <div className="col-sm-4">
              <img src={Service2} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
          </div>
        </div>
      </div>

      {/* AI Automation */}
      <div className="section-bg1 border-bottom border-secondary" id="ai-automation">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-4">
              <img src={Service3} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>AI Automation</h3>
              <p>Manual processes, repetitive approvals, document handling, and data entry between systems are where errors creep in and good people's time gets wasted. Jaggulas Consulting builds AI-driven automation that takes over these repeatable workflows, using AWS Lambda, Bedrock, and orchestration tools to connect your existing systems and apply intelligence where simple rules-based automation falls short.</p>
              <p>We start by mapping where time and accuracy are actually being lost in your operations, then automate the highest-impact processes first rather than automating everything at once. The result is a system that handles the repetitive work reliably, escalates the exceptions that genuinely need a person, and gives your team room to focus on decisions that require judgement rather than data entry.</p>
            </div>
          </div>
        </div>
      </div>

      {/* AI Consulting & Use-Case Roadmapping */}
      <div className="section-bg2 border-bottom border-secondary" id="ai-consulting">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>AI Consulting &amp; Use-Case Roadmapping</h3>
              <p>Most businesses know they should be doing something with AI, and most struggle to identify exactly what that something should be. Jaggulas Consulting provides AI consulting that starts with your actual operations, not a generic technology demo, to identify which AI use cases would deliver measurable value in your business and which are not worth the investment yet.</p>
              <p>We combine management consulting discipline with hands-on AWS technical expertise to produce a practical, phased roadmap: what to build first, what infrastructure it needs, what it will cost to run, and how to measure whether it worked. For healthcare and financial services organisations weighing AI adoption against regulatory and budget constraints, this is the step that turns AI from a buzzword into a funded, sequenced plan.</p>
            </div>
            <div className="col-sm-4">
              <img src={Service4} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
          </div>
        </div>
      </div>
      </section>

      <section className="pillar-group">
{/* ============ PILLAR 2: CLOUD & DEVOPS (AWS) ============ */}
      <div className="pillar-band">
        <div className="container">
          <h2 className="fw-bold pillar-title">Cloud &amp; DevOps</h2>
        </div>
      </div>

      {/* Cloud Migration & Modernization */}
      <div className="section-bg1 border-bottom border-secondary" id="cloud-migration-modernization">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-4">
              <img src={Service5} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>Cloud Migration &amp; Modernization</h3>
              <p>Legacy systems do not have to be a liability forever. Jaggulas Consulting plans and executes cloud migrations onto AWS, from straightforward lift-and-shift moves to full re-architecture of outdated platforms, so South African businesses get faster performance, lower infrastructure costs, and systems built to scale, without the downtime that usually comes with migration projects.</p>
              <p>We start with an assessment of what you are running today, map a migration path that fits your risk tolerance and timeline, and execute in phases so the business keeps operating throughout. Our completed work for clients like Qride shows the pattern: design, build, and deploy fully on AWS, with the legacy technical debt retired rather than just relocated. For businesses still running on ageing on-premise or outdated cloud setups, this is the service that removes the constraint blocking everything else on the roadmap.</p>
            </div>
          </div>
        </div>
      </div>

      {/* AWS Managed Services & Cost Optimisation (FinOps) */}
      <div className="section-bg2 border-bottom border-secondary" id="aws-managed-services">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>AWS Managed Services &amp; Cost Optimisation </h3>
              <p>Running AWS infrastructure well takes more than provisioning servers and walking away. Jaggulas Consulting provides round-the-clock monitoring, security patching, incident response, and governance for businesses across South Africa and the broader Southern African region, so your systems stay reliable while your team focuses on the business, not the infrastructure underneath it.</p>
              <p>This is a recurring relationship, not a one-off project. We have delivered ongoing managed services for clients including Siltbay, covering monitoring, maintenance, performance optimisation, and cost management on a continuous basis. As an AWS Partner with a dual-hub delivery model across Cape Town and Hyderabad, we combine direct AWS technical resources with cost-effective, always-on support, built around measurable uptime and spend efficiency rather than just ticket resolution.</p>
            </div>
            <div className="col-sm-4">
              <img src={Service6} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
          </div>
        </div>
      </div>

      {/* Cloud Security & Best-Practice Audits */}
      <div className="section-bg1 border-bottom border-secondary" id="cloud-security-audits">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-4">
              <img src={Service7} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>Cloud Security &amp; Best-Practice Audits</h3>
              <p>Most cloud environments accumulate gaps over time: security configurations that were right at launch and have drifted, cost inefficiencies nobody has had time to chase down, reliability risks that have not been tested. Jaggulas Consulting audits your AWS environment against established best practices across security, reliability, performance, and cost, and gives you a clear, prioritised view of what to fix first.</p>
              <p>The audit itself is the easy part. What matters is what happens after: we deliver a roadmap your team can act on immediately, sequenced by risk and effort, not a generic checklist. For businesses in regulated sectors like healthcare and financial services, this is also the groundwork for demonstrating due diligence to auditors, insurers, and enterprise customers who ask hard questions about your cloud posture.</p>
            </div>
          </div>
        </div>
      </div>

      {/* DevOps & Platform Engineering */}
      <div className="section-bg2 border-bottom border-secondary" id="devops-platform-engineering">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>DevOps &amp; Platform Engineering</h3>
              <p>Slow, manual deployments and fragile infrastructure slow teams down long after the initial build is finished. Jaggulas Consulting designs and implements DevOps practices and platform engineering on AWS, covering CI/CD pipelines, Kubernetes-based container orchestration, and infrastructure as code, so your releases become faster and safer rather than riskier as your systems grow.</p>
              <p>The goal is a platform your engineering team can build on confidently: infrastructure that is version-controlled and repeatable, deployments that can be rolled back in minutes rather than hours, and environments that look the same in staging as they do in production. We build this alongside your existing team, with knowledge transfer built in, so the platform remains yours to run long after the engagement ends.</p>
            </div>
            <div className="col-sm-4">
              <img src={Service8} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
          </div>
        </div>
      </div>
      </section>

      <section className="pillar-group">
{/* ============ PILLAR 3: SOFTWARE & DATA ENGINEERING ============ */}
      <div className="pillar-band">
        <div className="container">
          <h2 className="fw-bold pillar-title">Software &amp; Data Engineering</h2>
        </div>
      </div>

      {/* Custom Software Web & Mobile Applications */}
      <div className="section-bg1 border-bottom border-secondary" id="custom-software-web-applications">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-4">
              <img src={Service9} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>Custom Software Web &amp; Mobile Applications</h3>
              <p>Generic templates and off-the-shelf platforms eventually hit a ceiling, either they do not fit how your business actually works, or they cannot scale with you. Jaggulas Consulting builds custom web applications designed around your real workflows and user needs, architected natively on AWS from the first design decision rather than bolted on afterward.</p>
              <p>Our completed work for clients including Qride shows the full path: design, development, and deployment of a production application built specifically for the client's market and use case. We work in the same dual-hub model across Cape Town and Hyderabad that underpins all our delivery, giving South African businesses access to experienced engineering at a cost structure that holds up over a multi-year build.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Backend & API Integration */}
      <div className="section-bg2 border-bottom border-secondary" id="backend-api-integration">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>Backend &amp; API Integration</h3>
              <p>The visible part of an application is rarely where the real complexity lives. Jaggulas Consulting builds the backend systems and API integrations that hold everything together: the databases, server-side logic, and connections between your existing tools, payment systems, and third-party services that need to work reliably without anyone noticing them.</p>
              <p>We design APIs with centralised traffic management, security, and monitoring built in from the start, using AWS API Gateway and related services, so integrations stay maintainable as you add more systems over time. This is foundational work for any business running multiple platforms that need to share data accurately and securely.</p>
            </div>
            <div className="col-sm-4">
              <img src={Service10} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
          </div>
        </div>
      </div>

      {/* Data Engineering & Analytics */}
      <div className="section-bg1 border-bottom border-secondary" id="data-engineering-analytics">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-4">
              <img src={Service11} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>Data Engineering &amp; Analytics</h3>
              <p>Data sitting in disconnected systems is not an asset, it is a liability waiting to be acted on. Jaggulas Consulting builds the data pipelines, warehousing, and dashboards that turn raw operational data into something your team can actually use, drawing on AWS services to keep the architecture scalable as your data volume grows.</p>
              <p>Beyond standard business intelligence, we incorporate AI-driven analytics where it adds genuine predictive value, forecasting trends or flagging anomalies rather than just reporting on what already happened. For healthcare and financial services organisations, this work is built with the same data residency and compliance considerations that run through everything we deliver on AWS in South Africa.</p>
            </div>
          </div>
        </div>
      </div>
      </section>

      <section className="pillar-group">
{/* ============ PILLAR 4: TECHNOLOGY CONSULTING ============ */}
      <div className="pillar-band">
        <div className="container">
          <h2 className="fw-bold pillar-title">Technology Consulting</h2>
        </div>
      </div>

      {/* Cloud & Digital Transformation Strategy */}
      <div className="section-bg2 border-bottom border-secondary" id="cloud-digital-transformation-strategy">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>Cloud &amp; Digital Transformation Strategy</h3>
              <p>Digital transformation projects fail most often not because the technology is wrong, but because the strategy was never tied to a measurable business outcome in the first place. Jaggulas Consulting combines management consulting discipline with AWS technical delivery experience to build transformation roadmaps that are explicit about cost, sequencing, and what success actually looks like.</p>
              <p>This is strategic work, not a slide deck that sits unused after the workshop. We translate business objectives into a phased technology plan, covering cloud adoption, process modernisation, and where automation or AI genuinely fits, so that every recommendation comes with a reason it belongs in your specific business, not a generic transformation framework.</p>
            </div>
            <div className="col-sm-4">
              <img src={Service12} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
          </div>
        </div>
      </div>

      {/* CTO Advisory & Architecture Consulting */}
      <div className="section-bg1 border-bottom border-secondary" id="cto-advisory-architecture-consulting">
        <div className="container py-sm-5 py-5">
          <div className="row py-5 px-4 g-5 d-flex justify-content-center align-items-center">
            <div className="col-sm-4">
              <img src={Service13} alt="jaggulas consulting" className='img-fluid service-img'/>
            </div>
            <div className="col-sm-6 text">
              <h3 className='fw-bold mb-3'>CTO Advisory &amp; Architecture Consulting</h3>
              <p>Not every growing business needs a full-time CTO, but every growing business needs senior technical judgement applied to its biggest decisions. Jaggulas Consulting provides CTO advisory and architecture consulting for businesses that need experienced technology leadership on tap, for system design decisions, vendor evaluation, technical due diligence, or scaling questions that carry real cost if they get answered wrong.</p>
              <p>Our team brings AWS architecture expertise built over years of hands-on delivery, applied to your specific growth stage rather than generic best practice. This is most valuable at the inflection points: before a major rebuild, before a funding round that requires technical due diligence, or when an existing system needs a credible, independent assessment of whether it will scale.</p>
            </div>
          </div>
        </div>
      </div>
      </section>

{/* To top icon */}
        <ToTop />
        {/* To top icon */}

    </div>
  )
}
